import apiClient from '../axios.js'

/**
 * 城市和區域管理 API
 */
export const cityService = {
    /**
     * 獲取城市列表
     * @param {Object} params - 查詢參數
     * @param {boolean} params.includeInactive - 是否包含停用的城市
     * @returns {Promise<Object>} 城市列表
     */
    getCities: async (params = {}) => {
        const response = await apiClient.get('/cities', { params })
        return response
    },

    /**
     * 根據城市 ID 獲取區域列表
     * @param {string} cityId - 城市 ID
     * @param {Object} params - 查詢參數
     * @param {boolean} params.includeInactive - 是否包含停用的區域
     * @returns {Promise<Object>} 區域列表
     */
    getDistrictsByCityId: async (cityId, params = {}) => {
        const response = await apiClient.get(`/cities/${cityId}/districts`, { params })
        return response
    },

    /**
     * 根據城市代碼獲取區域列表
     * @param {string} cityCode - 城市代碼（例如：TPE, NTP）
     * @param {Object} params - 查詢參數
     * @param {boolean} params.includeInactive - 是否包含停用的區域
     * @returns {Promise<Object>} 區域列表
     */
    getDistrictsByCityCode: async (cityCode, params = {}) => {
        const response = await apiClient.get(`/cities/by-code/${cityCode}/districts`, { params })
        return response
    },
}
